<template>
    <div class="row m-0 p-2 col-12">
        <div
            class="d-flex align-items-center col-12 p-2 m-0 bg-secondary2"
            align-items-center
        >
            <i class="fa fa-home" role="button" @click="goHome"></i>
            <template v-for="(dir, i) in stack" :key="dir">
                <i class="fa fa-angle-right px-2"></i>
                <label role="button" class="m-0 p-0" @click="() => goDir(i)">{{
                    dir.toUpperCase()
                }}</label>
            </template>
        </div>
        <div class="row m-0 p-0 py-1 col-12">
            <template v-if="/^(\/)?premium(\/)?.*$/.test(path)">
                <div class="col-10 col-md-8 col-lg-5 col-xl-4 px-0 pr-2">
                    <input
                        type="search"
                        name="q"
                        class="form-control mx-0"
                        @submit="searchPremium"
                        :placeholder="t('premium-gifs.search')"
                        v-model="q"
                    />
                </div>
                <button
                    class="btn btn-primary"
                    type="button"
                    @click="searchPremium"
                >
                    <i class="fa fa-search"></i>
                </button>
            </template>
            <template v-else-if="!/^(\/)?mygifs(\/.*)?$/.test(path)">
                <div class="col-10 col-md-8 col-lg-5 col-xl-4 px-0 pr-2">
                    <input
                        type="search"
                        name="q"
                        class="form-control mx-0"
                        @submit="getPathWithQ"
                        placeholder="Procurar gifs"
                        v-model="q"
                    />
                </div>
                <button
                    class="btn btn-primary"
                    type="button"
                    @click="getPathWithQ"
                >
                    <i class="fa fa-search"></i>
                </button>
            </template>
            <template v-else>
                <button
                    class="mx-1 btn btn-warning"
                    type="button"
                    @click="showUpload = true"
                >
                    <i class="fa fa-plus-circle"></i> {{ t("new.addfiles") }}
                </button>
                <button
                    class="mx-1 btn btn-primary"
                    type="button"
                    @click="showCreateFolder = true"
                >
                    <i class="fa fa-folder-plus"></i> {{ t("new.newfolder") }}
                </button>
                <button
                    v-if="deleteFiles.length > 0"
                    class="mx-1 btn btn-danger"
                    type="button"
                    @click="deleteImages"
                >
                    <i class="fa fa-trash"></i> {{ t("my-gifs.delete") }} ({{ deleteFiles.length }})
                </button>
            </template>
        </div>

        <div class="row flex-wrap justify-content-evenly m-0 p-2 col-12">
            <template
                v-for="({ type, name, path }, i) in paginate(page)"
                :key="i"
            >
                <div
                    v-if="!path.startsWith('premium')"
                    role="button"
                    class="p-2 file-container col-4 col-md-3 col-lg-2"
                    @click="
                        () => {
                            (type == 'dir' ? go : selectGif)(
                                path,
                                type == 'usergif' ? 1 : 0,
                                this.path.replace('/mygifs', '').replace(/^\//, '') + '/' + name,
                            );
                        }
                    "
                >
                    <template v-if="type == 'usergif'">
                        <v-lazy-image :src="path" class="col-12" />
                        <input
                            type="checkbox"
                            :value="this.path.replace('/mygifs', '').replace(/^\//, '') + '/' + name"
                            @click.stop="() => {}"
                            @change="changeDelete"
                            class="position-absolute"
                            style="right: 1rem"
                        />
                    </template>
                    <v-lazy-image
                        v-else
                        :src="type == 'dir' ? folderIcon : getFullPath(path)"
                        class="col-12"
                    />
                    <input
                        v-if="this.path.startsWith('/mygifs')"
                        type="checkbox"
                        :value="this.path.replace('/mygifs', '').replace(/^\//, '') + '/' + name"
                        @click.stop="() => {}"
                        @change="changeDelete"
                        class="position-absolute"
                        style="right: 1rem"
                    />
                    <div
                        class="col-12 small p-0 m-0 text-center text-capitalize"
                    >
                        {{
                            name
                                .toLowerCase()
                                .replace("gifs ", "")
                                .replace(".gif", "")
                        }}
                    </div>
                </div>
                <div
                    v-else
                    role="button"
                    class="p-2 file-container col-4 col-md-3 col-lg-2"
                    @click="
                        () => {
                            (type == 'dir'
                                ? openPremiumGifs
                                : selectPremiumGif)(path);
                        }
                    "
                >
                    <v-lazy-image
                        :src="
                            type == 'dir'
                                ? folderIcon
                                : `${Api.url}premiun_gif?path=${path.replace('premium_gifs/', '')}&auth_token=${token}`
                        "
                        class="col-12"
                    />
                    <div
                        class="col-12 small p-0 m-0 text-center text-capitalize"
                    >
                        {{
                            name
                                .toLowerCase()
                                .replace("gifs ", "")
                                .replace(".gif", "")
                        }}
                    </div>
                </div>
            </template>

            <template
                v-if="
                    stack.length == 1 &&
                    stack[0].toLocaleLowerCase() == 'premium' &&
                    hasPremium
                "
            >
                <div class="alert alert-info col-12 p-0">
                    <div class="p-2">
                        <i class="fa fa-info-circle text-white mx-2"></i>
                        {{ t("premium-gifs.quality") }}
                    </div>
                </div>
            </template>

            <template v-if="!hasPremium && premiumPath(path)">
                <div>
                    <div class="row justify-center align-center col-12">
                        <p class="col-12">{{ t("premium-gifs.message") }}</p>
                        <iframe
                            width="860"
                            height="484"
                            :src="video"
                            class="col-12 col-md-10 col-lg-8 col-x-lg-6 youtube-video p-3 m-1"
                            title="Exemplo"
                            frameborder="0"
                            allow="
                                accelerometer;
                                autoplay;
                                clipboard-write;
                                encrypted-media;
                                gyroscope;
                                picture-in-picture;
                                web-share;
                            "
                            referrerpolicy="strict-origin-when-cross-origin"
                            allowfullscreen
                        >
                        </iframe>
                        <div class="col-12"></div>
                        <button
                            class="btn btn-primary btn-lg"
                            @click="buyPremium"
                        >
                            {{ t("premium-gifs.buy") }} (R$ {{ price }})
                        </button>
                    </div>
                </div>
            </template>

            <div
                v-if="path == '/' || path == ''"
                role="button"
                @click="() => go('/mygifs/')"
                class="p-2 file-container col-4 col-md-3 col-lg-2"
            >
                <v-lazy-image :src="userFolder" class="col-12" />
                <div class="col-12 small p-0 m-0 text-center text-capitalize">
                    {{ t("my-gifs.my-gifs") }}
                </div>
            </div>
            <div
                v-if="path == '/' || path == ''"
                role="button"
                @click="() => go('/premium/')"
                class="p-2 file-container col-4 col-md-3 col-lg-2"
            >
                <v-lazy-image :src="premiumFolder" class="col-12" />
                <div class="col-12 small p-0 m-0 text-center text-capitalize">
                    {{ t("premium-gifs.title") }}
                </div>
            </div>
        </div>
    </div>

    <modal-component
        v-if="showUpload"
        @hide="
            () => {
                showUpload = false;
            }
        "
        show
        :classList="['col-11 col-lg-10']"
        :title="t('my-gifs.upload')"
    >
        <div class="row col-12 m-0 p-1">
            <button class="btn btn-outline-primary mx-1" @click="clickSelect">
                <i class="fa fa-plus-circle"></i> {{ t("new.addfiles") }}
            </button>
            <button class="btn btn-outline-danger mx-1" @click="cleanFiles">
                <i class="fa fa-trash-alt"></i> {{ t("new.cleanfiles") }}
            </button>
        </div>
        <div class="alert alert-danger small">
            <i class="fa fa-info-circle"></i>
            {{ t("my-gifs.maxfiles").replace("{0}", limit.max_gifs) }}<br />
            <i class="fa fa-info-circle"></i>
            {{ t("my-gifs.maxsize").replace("{0}", limit.max_upload_size)
            }}<br />
        </div>
        <form @submit.prevent="send">
            <div class="col-12 p-2">
                <input
                    type="file"
                    @change="addFiles"
                    multiple
                    ref="fileinput"
                    class="d-none"
                />
                <div class="row p-1 m-0 col-12">
                    <div
                        v-for="(image, i) in uploadFiles"
                        :key="i"
                        class="file-container p-2 col-6 col-md-4 col-lg-3 position-relative"
                    >
                        <img
                            :src="getObjectUrl(image.file)"
                            class="col-12 img"
                        />
                        <input
                            type="text"
                            class="form-control"
                            required
                            v-model="image.name"
                            :placeholder="t('my-gifs.file-name')"
                        />
                        <i
                            @click="() => removeFile(i)"
                            role="button"
                            class="fa fa-trash-alt text-danger hover-icon position-absolute"
                        ></i>
                    </div>
                </div>

                <button
                    v-if="uploadFiles.length > 0"
                    type="submit"
                    class="btn btn-success my-2"
                >
                    Enviar
                </button>
            </div>
        </form>
    </modal-component>

    <modal-component
        @hide="() => (this.showCreateFolder = false)"
        :show="showCreateFolder"
        :classList="['col-10 col-md-7 col-lg-5']"
        :title="t('new.newfolder')"
    >
        <form @submit.prevent="makeDir" class="p-2">
            <label for="foldername">{{ t("new.foldername") }}</label>
            <input required class="form-control" type="text" id="foldername" name="foldername" v-model="folderName" :placeholder="t('new.foldername')" />

            <button type="submit" class="btn btn-success my-2">
                {{ t("treinos.create") }}
            </button>
        </form>
    </modal-component>
</template>

<script>
import Api, { getToken } from "@/utilities/Api";
import { mapActions, mapMutations } from "vuex";
import VLazyImage from "v-lazy-image";
import folderIcon from "../assets/icons/folder.svg";
import userFolder from "../assets/icons/user-folder.svg";
import premiumFolder from "../assets/icons/premium-folder.svg";
import { getExImage } from "@/utilities/HelpFunctions.js";

import { t } from "@/lang";
import ModalComponent from "./AdminLTE/Components/ModalComponent.vue";

export default {
    name: "SelectGifComponent",
    data() {
        return {
            folderName: t('new.foldername'),
            path: "abc/d/g",
            files: [],
            folderIcon,
            userFolder,
            premiumFolder,
            q: "",
            hasPremium: false,
            showCreateFolder: false,
            viewport: null,
            page: 1,
            showUpload: false,
            uploadFiles: [],
            deleteFiles: [],
            price: 0,
            token: "",
            limit: {
                user_id: 0,
                max_gifs: 1,
                max_upload_size: 3,
            },
            Api,
            video: "",
        };
    },
    async created() {
        document.title = "Fitnes";
        console.log(getToken());
        this.token = getToken();
        await this.getLimits();
        const res3 = await this.get({ url: "plans/premiun-gifs/1" });
        this.price = res3.data.price;
        this.video = res3.data.video;
        this.goHome();
    },
    components: {
        VLazyImage,
        ModalComponent,
    },
    unmounted() {},
    emits: ["selectGif", "selectPremium"],
    methods: {
        ...mapMutations(["SET_LOADING"]),
        ...mapActions(["get", "post", "delete"]),
        t,
        getFullPath(path) {
            return `${Api.url}images/GIFS/${path}`;
        },
        selectGif(gif, usergif = 0, name) {
            // tratar selected
            this.$emit("selectGif", gif, usergif, name);
        },
        selectPremiumGif(path) {
            // tratar selected
            console.log("Aqui");

            this.$emit(
                "selectPremium",
                path,
                `${Api.url}premiun_gif?path=${path.replace("premium_gifs/", "")}&auth_token=${this.token}`,
            );
        },
        paginate(page) {
            page;
            return this.files; //.slice((this.page - 1) * 12, (this,page - 1) * 12 + 12)
        },
        premiumPath(dir) {
            return /^(\/)?premium(\/)?$/.test(dir);
        },
        go(dir) {
            this.deleteFiles = []
            console.log(dir);
            if (/^(\/)?mygifs(\/.*)?$/.test(dir)) {
                this.openMyGifs(dir.replace("mygifs/", ""));
            } else if (/^(\/)?premium(\/)?$/.test(dir)) {
                this.openPremiumGifs();
            } else if (/^(\/)?premium(\/)?.*$/.test(dir)) {
                this.openPremiumGifs(dir.replace("premium/", ""));
            } else {
                this.page = 1;
                this.path = dir;
                this.getPath(dir);
            }
        },
        async deleteImages() {
            if (this.deleteFiles.length > 0) {
                const yes = confirm(t("my-gifs.confirm-delete"));
                if (yes) {
                    this.SET_LOADING(true);
                    const params = new URLSearchParams();
                    this.deleteFiles.forEach((name) =>
                        params.append("names[]", name),
                    );
                    const res = await this.delete({
                        url: "user-gifs?" + params.toString(),
                    });
                    // console.log(res)
                    if (res.status >= 200 && res.status < 300) {
                        alert(this.t("general.deleted"));
                    } else {
                        alert("Error\n\n\n" + res.data?.message);
                    }
                    this.SET_LOADING(true);

                    this.go(this.path);
                }
            }
        },
        changeDelete({ target: { value: v, checked } }) {
            // const path = this.path.replace("/mygifs", "").replace(/^\//, "")
            const value = v//path + "/" + v
            if (checked) {
                if (!this.deleteFiles.includes(value)) {
                    this.deleteFiles.push(value);
                }
            } else {
                if (this.deleteFiles.includes(value)) {
                    this.deleteFiles.splice(this.deleteFiles.indexOf(value), 1);
                }
            }
            console.log(value);
        },
        clickSelect() {
            this.$refs.fileinput.click();
        },
        addFiles({ target: { files } }) {
            for (let i = 0; i < files.length; i++) {
                const file = files[i];
                const { name } = file;
                const byteSize = file.size;
                const mbSize = byteSize / (1024 * 1024);

                if (mbSize > this.limit.max_upload_size) {
                    alert(
                        t("my-gifs.out-size")
                            .replace("{0}", name)
                            .replace("{1}", this.limit.max_upload_size),
                    );
                    continue;
                } else if (!/.+(\.gif)$/.test(name)) {
                    alert(t("my-gifs.not-gif").replace("{0}", name));
                    continue;
                } else {
                    const baseName = file.name.substring(
                        0,
                        file.name.lastIndexOf("."),
                    );
                    this.uploadFiles.push({ name: baseName, file: file });
                }
            }
        },
        cleanFiles() {
            this.uploadFiles = [];
        },
        removeFile(i) {
            this.uploadFiles.splice(i, 1);
        },
        async send() {
            if (this.uploadFiles.length > 0) {
                if (
                    this.files.length + this.uploadFiles.length >
                    this.limit.max_gifs
                ) {
                    alert(
                        t("my-gifs.maxfiles").replace(
                            "{0}",
                            this.limit.max_gifs,
                        ),
                    );
                    return false;
                }
                this.SET_LOADING(true);
                const formData = new FormData();
                const path = this.path.replace("/mygifs", "").replace(/^\//, "")
                console.log("PATH => ", path)
                formData.append("path", path)

                for (const image of this.uploadFiles) {
                    formData.append(`images[${image.name}]`, image.file);
                }

                const res = await this.post({
                    url: "user-gifs",
                    formData: true,
                    data: formData,
                });

                if (res.status >= 200 && res.status < 300) {
                    alert(t("files.added"));
                    this.showUpload = false;
                    this.uploadFiles = [];
                } else if (res.status == 422) {
                    alert(
                        t("my-gifs.error").replace(
                            "{0}",
                            this.limit.max_upload_size,
                        ),
                    );
                } else {
                    alert("Error\n\n" + res.data?.message);
                }

                this.go(this.path);
                console.log(res);
                this.SET_LOADING(false);
            } else {
                return;
            }
        },
        getObjectUrl(blob) {
            return URL.createObjectURL(blob);
        },
        async openMyGifs(path = "") {
            this.SET_LOADING(true);
            this.deleteFiles = []
            this.page = 1;
            this.path = "/mygifs/" + path;

            this.files = [];
            const dirs = await this.get({ url: `user-gifs/dirs?path=${path}` })
            console.log(dirs.data)
            if (dirs.status == 200) {
                this.files.push(...dirs.data.dirs)
            }
            const res = await this.get({ url: `user-gifs?path=${path}` });
            if (res.status == 200) {
                const files = res.data.files;
                const gets = files.map(async (file) => {
                    return new Promise((resolve) => {
                        getExImage(
                            "",
                            this.get,
                            `user-gifs/download?path=${path + "/" + file}`,
                            "image/gif",
                        )
                            .then((url) => {
                                this.files.push({
                                    type: "usergif",
                                    name: file,
                                    path: url,
                                });
                            })
                            .finally(resolve);
                    });
                });
                await Promise.all(gets);
            } else {
                alert("Error");
            }
            console.log(res);
            this.SET_LOADING(false);
        },
        async openPremiumGifs(path = "") {
            this.SET_LOADING(true);
            this.page = 1;
            path = path.replace("premium_gifs/", "");
            this.path = `/premium/${path}`;

            this.files = [];
            const res = await this.get({ url: `premiun-gifs?path=${path}` });
            if (res.status == 200) {
                const files = res.data.files;
                this.files = files;
                this.hasPremium = true;
            } else if (res.status == 400) {
                this.hasPremium = false;
                alert(t("premium-gifs.error-message"));
            } else {
                this.hasPremium = false;
                alert("Error");
            }
            console.log(res);
            this.SET_LOADING(false);
        },
        async searchPremium() {
            this.SET_LOADING(true);
            this.page = 1;
            this.files = [];
            const res = await this.get({
                url: `premiun-gifs/search?q=${this.q}`,
            });
            if (res.status == 200) {
                const files = res.data.files;
                this.files = files;
                this.hasPremium = true;
            } else {
                this.hasPremium = false;
                alert("Error");
            }
            console.log(res);
            this.SET_LOADING(false);
        },
        goHome() {
            this.go("/");
        },
        goDir(index) {
            let fullPath = "";
            for (let i = 0; i <= index; i++) {
                fullPath += this.stack[i] + "/";
            }

            console.log("Go to dir: ", this.stack[index], "Full: ", fullPath);
            this.go(fullPath);
        },

        async getPathWithQ() {
            if (this.q.length > 0) {
                await this.getPath(undefined, this.q);
            }
        },
        async buyPremium() {
            this.SET_LOADING(true);
            const response = await this.get({ url: `payment/premiun-gifs` });
            if (response.status == 200) {
                console.log(response.data);
                try {
                    open(response.data.url);
                } catch (e) {
                    alert(t("payment.need-click"));
                }
            } else {
                alert(response.data.message);
            }
            this.SET_LOADING(false);
        },
        async getPath(path = "", q = null) {
            this.SET_LOADING(true);
            this.files = [];

            try {
                this.page = 1;
                const { data } = await this.get({
                    url: `files?path=${path}` + (q ? `&q=${q}` : ""),
                });
                this.files = data.files;
            } catch (e) {
                alert("Ocorreu um erro buscando os arquivos");
                console.log(e);
            } finally {
                this.SET_LOADING(false);
            }
        },
        // user-gifs
        async getLimits() {
            const res = await this.get({ url: `user-gifs/limits` });
            if (res.status == 200) {
                const limit = res.data.gifs_limit;

                this.limit.max_gifs = limit.max_gifs;
                this.limit.max_upload_size = limit.max_upload_size / 1024;
                this.limit.user_id = limit.user_id;
                console.log(res.data);
            } else {
                alert("Error");
                console.log(res);
            }
        },
        async makeDir() {
            this.SET_LOADING(true);

            const path = this.path.replace("/mygifs", "").replace(/^\//, "")
            console.log(this.folderName, path)
            const res = await this.post({
                url: "user-gifs/mkdir",
                formData: false,
                data: {name: this.folderName, path},
            });

            console.log(res);
            if (res.status >= 200 && res.status < 300) {
                // this.go(this.path);
                this.files.push({type: "dir", name: this.folderName, path: this.path + "/" + this.folderName});
                alert(t("new.foldercreated"));
                this.showCreateFolder = false
            } else {
                alert("Error\n\n" + res.data?.message);
            }
            this.newFolder = false;
            this.SET_LOADING(false);
        },
    },

    computed: {
        stack() {
            console.log(
                this.path.split("/").filter((value) => value.length > 0),
            );
            return this.path.split("/").filter((value) => value.length > 0);
        },
    },
};
</script>

<style scoped lang="scss">
.file-container {
    transition: all 0.3s ease-in-out;
    border-radius: 7px;
    &:hover {
        transform: scale(1.05);
        // background: rgba(200, 200, 200, 0.7);
    }

    .img {
        aspect-ratio: 1 / 1; /* Define a proporção 1:1 (quadrado) */
        object-fit: contain;
    }
}

.pages {
    border: 1px solid gray;

    .paginate {
        width: 2rem !important;
        height: 2rem !important;
        font-weight: bold;
        text-align: center;
        vertical-align: middle;
    }
}
</style>
